import React, { useRef } from "react";
import { toast } from "react-hot-toast";
import emailjs from "@emailjs/browser";

const ContactModal = () => {
  const form = useRef();
  const handleFormSubmit = (event) => {
    event.preventDefault();
    const form = event.target;
    const name = form.fullName.value;
    const email = form.email.value;
    const message = form.message.value;
    const emailBody = { name, email, message };
    //hello form to send email
    emailjs.sendForm();
    emailjs
      .sendForm(
        "service_zfn70bg",
        "template_gfc5ms1",
        event.target.value,
        "ntpAh47kSz48PeA9L"
      )
      .then(
        (result) => {
          console.log(result.text);
        },
        (error) => {
          console.log(error.text);
        }
      );

    //hello form to send email

    form.reset();
    toast.success("Thank you for contacting with me");
  };
  return (
    <div>
      <input type="checkbox" id="my-modal" className="modal-toggle" />
      <div className="modal">
        <div className="modal-box">
          <label
            htmlFor="my-modal"
            className="btn btn-sm btn-secondary btn-circle absolute right-2 top-2"
          >
            ✕
          </label>
          <div className="">
            <div className="hero-content flex-col lg:flex-row-reverse">
              <div className="card flex-shrink-0 w-full ">
                <form
                  className="card-body"
                  action="https://public.herotofu.com/v1/4ba41a20-794a-11ed-a126-b172cf164538"
                  method="post"
                >
                  <div className="form-control">
                    <label className="label" for="name">
                      Your Name
                    </label>
                    <input
                      className="input input-bordered"
                      name="Name"
                      id="name"
                      type="text"
                      required
                    />
                  </div>
                  <div className="form-control">
                    <label className="label" for="email">
                      Your Email
                    </label>
                    <input
                      className="input input-bordered"
                      name="Email"
                      id="email"
                      type="email"
                      required
                    />
                  </div>
                  <div className="form-control">
                    <label className="label" for="message">
                      Message
                    </label>
                    <textarea
                      className="input input-bordered"
                      name="message"
                      id="message"
                      type="text"
                    />
                  </div>
                  <div className="form-control">
                    <input
                      className="btn btn-secondary mt-4"
                      type="submit"
                      value="Submit"
                    />
                  </div>
                </form>
                {/* <form
                  id="myForm"
                  ref={form}
                  onSubmit={handleFormSubmit}
                  className="card-body"
                >
                  <div className="form-control">
                    <label className="label">
                      <span className="label-text">Full Name</span>
                    </label>
                    <input
                      type="text"
                      placeholder="Full Name"
                      className="input input-bordered"
                      name="fullName"
                      id="fullName"
                    />
                  </div>
                  <div className="form-control">
                    <label className="label">
                      <span className="label-text">Email</span>
                    </label>
                    <input
                      type="email"
                      placeholder="email"
                      className="input input-bordered"
                      name="email"
                      id="email"
                    />
                  </div>
                  <div className="form-control">
                    <label className="label">
                      <span className="label-text">Message</span>
                    </label>
                    <input
                      type="text"
                      placeholder="Message"
                      className="input input-bordered"
                      name="message"
                      id="message"
                    />
                  </div>
                  <div className="form-control mt-6 modal-action">
                    <button
                      type="submit"
                      htmlFor="my-modal"
                      className="btn btn-secondary"
                      value="Submit"
                    >
                      Submit
                    </button>
                  </div>
                </form> */}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ContactModal;
